// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_1CzI3","tooltip":"index_tooltip_1nR8Z"};